module.exports = ".container{\r\n    padding: 0;\r\n    margin: 0;\r\n}"